import { smartAdvisor } from "images";
import React, { useState, useEffect } from "react";
import classes from "./ResponseImage.module.css";
const ResponseImage = ({ msg }) => {
  const [loading, setLoading] = useState(true);
  // console.log("loadedImg",msg.images[0]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 10); // Adjust the timeout duration as needed

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={classes.wrapper}>
      {loading ? (
        <div className={classes.loader}>
          <div className={classes.circle}></div>
        </div> // You can style this loader as per your design
      ) : (
        <img
          src={`data:image/png;base64,${msg?.images[0]}`}
          alt="Loaded content"
          className={classes.img}
        />
        // <></>
      )}
    </div>
  );
};

export default ResponseImage;
